import { connect } from "react-redux";
import Search from "../../../components/search/Search";

export default connect((_) => ({}), {})(Search);
